import { useState } from 'react'
import type { ProductCheckout } from '@entities/product/api/product.contract'
import { ImageUploadField, SegmentedControl, TextField } from '@shared/design-system/ui'
import { useFeatureFlag } from '@shared/feature-flags/useFeatureFlag'
import { isAbsoluteHttpUrl } from '@shared/lib/url/absolute-http-url'
import { fieldBlock, fieldLabel } from './CheckoutBuilder.css'

export const bannerVideoUrlError =
  'Informe uma URL completa de vídeo, começando com https:// ou http://.'

export function CheckoutBannerField({
  checkout,
  onChange,
}: {
  checkout: ProductCheckout
  onChange: (input: Partial<ProductCheckout>) => void
}) {
  const enabled = useFeatureFlag('checkoutBannerVideo')
  const videoUrl = checkout.bannerVideoUrl ?? ''
  const [videoSelected, setVideoSelected] = useState(videoUrl !== '')
  const mode = enabled && (videoSelected || videoUrl !== '') ? 'video' : 'image'

  return (
    <div className={fieldBlock} data-testid="checkout-banner-field">
      {enabled && (
        <>
          <span className={fieldLabel}>Banner do checkout</span>
          <SegmentedControl
            ariaLabel="Tipo do banner do checkout"
            value={mode}
            options={[
              { label: 'Imagem', value: 'image' },
              { label: 'Vídeo', value: 'video' },
            ]}
            onChange={(value) => {
              setVideoSelected(value === 'video')
              if (value === 'image') onChange({ bannerVideoUrl: '' })
            }}
          />
        </>
      )}
      {mode === 'video' ? (
        <TextField
          label="URL do vídeo do checkout"
          data-testid="checkout-banner-video-url"
          value={videoUrl}
          placeholder="https://..."
          helperText="YouTube, Vimeo, Loom, VTurb, Panda Video ou URL de player incorporável e arquivo de vídeo."
          error={
            isAbsoluteHttpUrl(videoUrl, { allowEmpty: true, allowHash: true })
              ? undefined
              : bannerVideoUrlError
          }
          onChange={(event) => onChange({ bannerVideoUrl: event.target.value })}
        />
      ) : (
        <ImageUploadField
          label={enabled ? 'Imagem do banner' : 'Banner do checkout'}
          kind="banner"
          value={checkout.bannerUrl}
          onChange={(bannerUrl) => onChange({ bannerUrl })}
          aspect="20 / 6"
          hint="ideal 1600x540"
          allowUrl
        />
      )}
    </div>
  )
}
